'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["style", "height", "fontSize", "lineHeight", "hasAnyBorder", "onlyLeftAndRightBorders"];
import PropTypes from 'prop-types';
import { StyledIconButton } from './styledButtons';
import UIIcon from 'UIComponents/icon/UIIcon';
import { jsx as _jsx } from "react/jsx-runtime";
const ToolbarDropdownIconButton = props => {
  const {
      style,
      height,
      fontSize,
      lineHeight,
      hasAnyBorder,
      onlyLeftAndRightBorders
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);

  // Intentionally using the `fontSize` for the caret instead of the parent's `iconSize`
  // because the mocks keep the dropdown carat icon the same size even in toolbars
  // that have different icon sizes.
  const adjustedIconSize = fontSize - 3;
  const fontSizeForBetterVerticalCentering = 10;
  const iconButtonWidth = 22;
  return /*#__PURE__*/_jsx(StyledIconButton, Object.assign({
    size: "xs",
    fontSize: fontSizeForBetterVerticalCentering,
    width: iconButtonWidth,
    height: height,
    lineHeight: lineHeight,
    hasAnyBorder: hasAnyBorder,
    onlyLeftAndRightBorders: onlyLeftAndRightBorders,
    style: style
  }, rest, {
    children: /*#__PURE__*/_jsx(UIIcon, {
      name: "downCarat",
      size: adjustedIconSize
    })
  }));
};
ToolbarDropdownIconButton.propTypes = {
  height: PropTypes.number.isRequired,
  fontSize: PropTypes.number.isRequired,
  lineHeight: PropTypes.number.isRequired,
  hasAnyBorder: PropTypes.bool.isRequired,
  onlyLeftAndRightBorders: PropTypes.bool.isRequired,
  style: PropTypes.object
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
ToolbarDropdownIconButton.defaultProps = {
  style: {}
};
export default ToolbarDropdownIconButton;